import { render, staticRenderFns } from "./preview-option.vue?vue&type=template&id=50866f62"
import script from "./preview-option.vue?vue&type=script&lang=js"
export * from "./preview-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports